// GENERATED by scripts/floor-polyfills.mjs. Do not edit: run `node scripts/floor-polyfills.mjs`.
// test_981_floor_polyfill_list_fresh fails when this file is stale.
//
// core-js 3.50.0. Every native a core-js module the polyfills load replaces on a current
// engine: named by its CURRENT_ENGINE_MODULES entry (core-js-compat data), or seen replaced when
// the module ran alone on the pinned current engine (Chromium 143.0.7499.4; npm run floor:sweep,
// scripts/floor-boot/current-engine-natives.json). src/lib/floorNativeGuard.ts puts each back.
// Dotted paths from `globalThis`.
export const GUARDED_NATIVES: readonly string[] = [
  'DOMException',
  'DOMException.prototype.constructor',
  'Function.prototype.toString',
  'Iterator.prototype.drop',
  'Iterator.prototype.take',
  'Promise.try',
  'Uint8Array.prototype.setFromHex',
  'structuredClone',
];
